// The calculator and its report must use the same complete-calendar-month rule.
export function addMonths(date: Date, months: number, forcedDay?: number) {
  const day = forcedDay ?? date.getUTCDate();
  const base = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + Math.round(months), 1, 12));
  const lastDay = new Date(Date.UTC(base.getUTCFullYear(), base.getUTCMonth() + 1, 0, 12)).getUTCDate();
  base.setUTCDate(Math.min(day, lastDay));
  return base;
}

export function calendarMonthsBetween(start: Date | null, end: Date | null) {
  if (!start || !end || end < start) return 0;
  const months = (end.getUTCFullYear() - start.getUTCFullYear()) * 12 + end.getUTCMonth() - start.getUTCMonth();
  return Math.max(0, months - (addMonths(start, months) > end ? 1 : 0));
}
